import { colors } from '@ardoq/design-tokens';
import { ContentControls } from './types';

export const FULL_TRANSPARENT = 'transparent';
export const DARK_BACKGROUND_COLOR = colors.grey700;

export const DEFAULT_CONTENT_CONTROLS: ContentControls = {
  center: true,
  zoomIn: true,
  zoomOut: true,
  reset: true,
};
